module.exports = __webpack_public_path__ + "img/67-clock-outline.ef00a29a.gif";